import { render, staticRenderFns } from "./FinancesPayrolls.vue?vue&type=template&id=19bdaf90&"
import script from "./FinancesPayrolls.vue?vue&type=script&lang=js&"
export * from "./FinancesPayrolls.vue?vue&type=script&lang=js&"
import style0 from "./FinancesPayrolls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports